import React from "react"
import { ResetPasswordRequest } from "../../generated"
import UserActions from "../LoginActions"
import { RouteComponentProps } from "react-router-dom"
import { Forms } from "../../common/components/CmForms"
import * as Yup from "yup";
import { messageAlert } from "../../common/components/confirm"

type FormData = { newPassword: string, confirmNewPassword: string };
const { Form, Submit, FormText } = Forms<FormData>();

export function getParameterByName(location: Location, name: string): string {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.href);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}


interface Props extends RouteComponentProps {

}

interface State {
    resetOk: boolean | undefined;
}

export default class ResetPassword extends React.Component<Props, State>
{
    constructor(props: Props) {
        super(props);
        this.state = {
            resetOk: undefined,
        }
    }

    private resetPassword = async (e: FormData) => {
        var resetRequest: ResetPasswordRequest = new ResetPasswordRequest({
            email: getParameterByName(window.location, "user"),
            resetToken: getParameterByName(window.location, "token"),
            newPassword: e.newPassword
        });

        if (await UserActions.resetPassword(resetRequest)) {
            await messageAlert(<div className="alert alert-success text-center" role="alert" style={{ fontSize: "1.2em" }}>
                <div className="mb-2"><i className="far fa-thumbs-up fa-5x" /></div>
                <div>La tua password è stata aggiornata. Puoi ora effetturare la login utilizzando le nuove credenziali.</div>
            </div>, "Registrazione completata!")
            this.props.history.push("login");
        }
        else {
            await messageAlert(<div className="alert alert-danger text-center" role="alert" style={{ fontSize: "1.2em" }}>
                <div className="mb-2"><i className="far fa-frown fa-5x" /></div>
                <div>Si è verificato un errore imprevisto. Se l'errore persiste contattare l'assistenza!</div>
            </div>, "Errore")
        }
    }

    render() {
        return (
            <div className="container">

                <div className="card card-outline-info">
                    <div className="card-header text-white">Cambia Password</div>
                    <div className="card-body">
                        <Form
                            initialValues={{ newPassword: "", confirmNewPassword: "" }}
                            onSubmit={this.resetPassword}
                            noPrompt
                            validationSchema={Yup.object<FormData>({
                                newPassword: Yup
                                    .string()
                                    .required('Campo obbligatorio'),
                                confirmNewPassword: Yup
                                    .mixed()
                                    .test('confirmNewPassword', 'Le password non corrispondono', function (value) {
                                        const { newPassword } = this.parent;
                                        return newPassword === value;
                                    })
                            })}
                        >
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <FormText
                                            type="password"
                                            label="Password"
                                            name="newPassword"
                                        />
                                    </div>
                                    <div className="col-12">
                                        <FormText
                                            type="password"
                                            label="Conferma Password"
                                            name="confirmNewPassword"
                                        />
                                    </div>
                                </div>
                                <Submit alwaysActive>Reimposta la password</Submit>
                            </>
                        </Form>
                    </div>
                </div >
            </div >
        );
    }
}
